import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/transactions')({
  validateSearch: (search) => ({
    bookId: typeof search.bookId === 'string' ? search.bookId : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/portfolio',
      search: {
        tab: 'transactions',
        ...(search.bookId ? { bookId: search.bookId } : {}),
      },
    })
  },
})
